import {z as zod} from "zod";

export type FlexibleFitmentEngineWorkspaceCapabilityConfiguration = {
    allowFitmentNodeAttributes: boolean;
};

export const flexibleFitmentEngineWorkspaceCapabilityConfigurationValidator: zod.ZodType<FlexibleFitmentEngineWorkspaceCapabilityConfiguration> = zod.strictObject({
    allowFitmentNodeAttributes: zod.boolean(),
});
